'use strict';
/**
 * @author Romatel
 */
export default ['$resource', function($resource) {
    return $resource('api/hazards/:classId', { classId: "@id"}, {
        getAll: {method: 'GET'},
        get: {method: 'GET'},
        create: {url: 'api/hazards', method: 'POST'},
        update: {url: 'api/hazards/:classId', method: 'PUT'},
        remove: {url: 'api/hazards/:classId/delete-logically', method: 'POST'},
        enable: {url: 'api/hazards/:classId/enable', method: 'PUT'},
        delete: {url: 'api/hazards/:classId', method: 'DELETE'},
        getDefault: {url: 'api/hazards/default', method: 'GET'},
        setDefault: {url: 'api/hazards/:classId/default', method: 'POST'},
        isUniqueName: {url: 'api/hazards/unique/name/:name', method: 'GET'},
        exists: {url: 'api/hazards/exists', method: 'GET'},
    });
}];
